import axios from "./axios"

const updateTaggedDateAPI = async (payload) => {
	const api = `/file/tagged_date?file_id=${payload?.fileId}&tagged_date=${payload?.taggedDate}`
	return await axios
		.put(api, payload)
		.then((response) => {
			return response
		})
		.catch((error) => {
			console.log("Error", error)
			return error
		})
}

export const taggedDateServices = {
	updateTaggedDateAPI,
}
